module.exports = __webpack_public_path__ + "static/img/8.5a83fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/8.jpg
// module id = RB4q
// module chunks = 16